var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 860.000000 780.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,780.000000) scale(0.100000,-0.100000)",
    fill: "#CCAA60",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4015 7390 c-694 -62 -1328 -312 -1881 -740 -140 -109 -475 -444 -584 -584 -669 -864 -903 -1941 -650 -2991 117 -485 333 -932 650 -1341 112 -145 445 -476 590 -588 522 -402 1074 -630 1745 -722 184 -25 646 -25 830 0 676 92 1228 321 1751 726 145 112 476 445 588 590 403 523 630 1072 722 1745 25 184 25 646 0 830 -92 676 -322 1229 -727 1751 -109 141 -443 476 -582 583 -527 407 -1086 639 -1752 727 -134 18 -562 26 -700 14z m630 -275 c826 -93 1563 -479 2101 -1100 364 -421 623 -950 728 -1493 66 -340 76 -767 25 -1102 -50 -331 -156 -666 -307 -968 -160 -318 -349 -580 -607 -837 -257 -258 -517 -446 -835 -605 -462 -232 -924 -340 -1450 -340 -538 0 -996 110 -1475 353 -607 309 -1109 816 -1417 1429 -250 499 -360 1025 -337 1600 33 804 368 1559 949 2138 519 519 1175 834 1920 924 157 19 541 20 705 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4095 6083 c-63 -8 -229 -45 -298 -67 -477 -152 -874 -548 -1032 -1030 -163 -497 -70 -1058 282 -1711 251 -464 645 -988 1084 -1439 l164 -169 124 129 c720 749 1211 1500 1395 2133 65 223 81 330 80 556 0 171 -3 216 -23 310 -123 580 -520 1032 -1071 1216 -172 57 -317 79 -513 78 -89 -1 -175 -4 -192 -6z m337 -1012 c249 -64 424 -258 457 -507 38 -276 -130 -552 -391 -644 -382 -134 -782 129 -806 531 -10 177 50 332 177 459 154 153 361 212 563 161z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.3ca524df08e4e1750ec7c37f8a390caf.svg";
export { ForwardRef as ReactComponent };